export default __webpack_public_path__ + "static/1-b3ad23cdbc33e0022918873336c4c7e2.png";